import { useState } from 'react';
import { isValidEmail } from '../utils/isValidEmail';
import { validatePassword } from '../utils/isValidPassword';
import styles from '../Components/CheckoutForm/Shared/shared.module.css';

export const INVALID_CLASS = styles.invalid;

const useValidation = () => {
  const [validationClass, setValidationClass] = useState('');
  const [hasBeenValidated, setHasBeenValidated] = useState(false);
  const isInvalid = validationClass === INVALID_CLASS;

  const validateValue = (name: string, value: string) => {
    if (name === 'email') {
      if (!isValidEmail(value)) {
        return setValidationClass(INVALID_CLASS);
      }
    }
    if (name === 'password') {
      if (!validatePassword(value)) {
        return setValidationClass(INVALID_CLASS);
      }
    }
    if (value.length === 0) {
      return setValidationClass(INVALID_CLASS);
    }
    return setValidationClass('');
  };

  const handleValidationChange = (name: string, value: string) => {
    if (hasBeenValidated) {
      return validateValue(name, value);
    }
    return validationClass;
  };

  const handleValidationBlur = (name: string, value: string) => {
    if (!hasBeenValidated) {
      setHasBeenValidated(true);
      return validateValue(name, value);
    }
    return validationClass;
  };

  return {
    isInvalid,
    validationClass,
    validateValue,
    hasBeenValidated,
    setHasBeenValidated,
    handleValidationChange,
    handleValidationBlur,
  };
};

export default useValidation;
